<div *ngIf="isActivated">
  <app-change-password></app-change-password>
</div>
<div class="admin" *ngIf="!isActivated">
  <div class="login row d-flex flex-column justify-content-center align-items-center">
    <div class="logo d-flex align-items-center justify-contet-between">
      <a>
        <img src="../../../assets/images/MC-white.svg" />
      </a>
      <div class="slogan">
        <span class="slogan-ar"> مركز الامتياز التجاري </span>
        <span class="slogan-en"> Franchise Center </span>
      </div>
    </div>

    <div class="col-md-4">
      <form class="form login-form">
        <!-- <div class="activated" *ngIf="!isInvalid && isActivated && !isExpired">
          <div class="form-group">
            <p style="padding: 0% 30%;"><i class="fa-regular fa-envelope fa-2xs"></i></p>
            <h1 class="text-center">{{"EmailActivation.Success" | translate}}</h1>
          </div>
          <div class="login-button">
            <a class="btn btn-primary btn-block" routerLink="/adminlogin">تسجيل الدخول</a>
          </div>
        </div> -->

        <div class="expired" *ngIf="!isInvalid && !isActivated && isExpired">
          <div class="form-group">
            <p style="padding: 0% 30%;"><i class="fa-regular fa-envelope fa-2xs"></i></p>
            <h1 class="text-center">{{"EmailActivation.ExpiredLink" | translate}}</h1>
          </div>
          <div class="login-button">
            <button class="btn btn-primary btn-block">إعادة إرسال</button>
          </div>
        </div>

        <div class="invalid" *ngIf="isInvalid && !isActivated && !isExpired">
          <div class="form-group">
            <p style="padding: 0% 30%;"><i class="fa-regular fa-envelope fa-2xs"></i></p>
            <h1 class="text-center">{{invalidMessage}}</h1>
          </div>
        </div>

      </form>
    </div>
  </div>
</div>